import request from '@/utils/request';
import { useFd } from '@/utils/formData'

/**
 * AEW Client Articles API For Index
 */
export function fetchArticleList({ categoryId, page, type = 1 }) {
  const data = useFd('AEW/Client/ArticleList', {
    project_id: 1,
    article_category_id: categoryId,
    type,
    page
  })
  return request({
    method: 'post',
    data,
  })
}

export function fetchArticle(article_id, __dbid_origin) {
  const data = useFd('AEW/Client/ArticleDetail', {
    article_id,
    __dbid_origin: __dbid_origin || 2,
  })
  return request({
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/client/Articles.js